import React, { forwardRef } from 'react';
import FocusLock from 'react-focus-lock';
import { UserMenuItem } from '../../menu-item';
import {
  PackageIcon,
  UserFocusIcon,
  IdentificationBadgeIcon,
  BriefcaseIcon,
  SignOutIcon,
} from '@fronton/icons-react';
import { patchUrlByLocale } from 'utils';
import { useTranslation } from 'react-i18next';
import { Divider } from 'fronton-react';
import { ContentClassName, OrganizationItemClassName, OrganizationNameClassName } from './style';

const DATA_QA_B2B_PROFILE_ORGANIZATION_NAME = 'b2b-profile-organization-name';
const DATA_QA_B2B_PROFILE_ORGANIZATIONS = 'b2b-profile-organizations';
const DATA_QA_B2B_PROFILE_PRIVATE_INFO = 'b2b-profile-private-info';
const DATA_QA_B2B_PROFILE_CHANGE_ORGANIZATION = 'b2b-profile-change-organization';
const DATA_QA_B2B_PROFILE_LOGOUT = 'b2b-profile-logout';
const DATA_QA_B2B_PROFILE_TOOLTIP_CONTENT = 'b2b-profile-tooltip_content';

const ORGANIZATIONS_URL = '/lkb2b/organization/';
const PROFILE_URL = '/lkb2b/personal-info/';

type ContentProps = {
  organizationName?: string;
  organizationCount: number;
  onLogout: () => void;
  showChangeOrganizationPopup: () => void;
};

export const Content = forwardRef<HTMLDivElement, ContentProps>((props, ref) => {
  const { t } = useTranslation();

  return (
    <div className={ContentClassName} ref={ref} data-qa={DATA_QA_B2B_PROFILE_TOOLTIP_CONTENT}>
      <FocusLock>
        <UserMenuItem
          icon={IdentificationBadgeIcon}
          className={OrganizationItemClassName}
          as={'span'}
          data-qa={DATA_QA_B2B_PROFILE_ORGANIZATION_NAME}
        >
          <span className={OrganizationNameClassName}>{props.organizationName || ''}</span>
        </UserMenuItem>
        <Divider />
        {props.organizationCount > 1 && (
          <UserMenuItem
            icon={BriefcaseIcon}
            href={patchUrlByLocale({ url: ORGANIZATIONS_URL })}
            data-qa={DATA_QA_B2B_PROFILE_ORGANIZATIONS}
          >
            {t('header.main.b2b-user-menu.organizations')}
          </UserMenuItem>
        )}
        <UserMenuItem
          icon={PackageIcon}
          href={patchUrlByLocale({ url: PROFILE_URL })}
          data-qa={DATA_QA_B2B_PROFILE_PRIVATE_INFO}
        >
          {t('header.main.b2b-user-menu.private')}
        </UserMenuItem>
        <Divider />
        {props.organizationCount > 1 && (
          <UserMenuItem
            icon={UserFocusIcon}
            onClick={props.showChangeOrganizationPopup}
            data-qa={DATA_QA_B2B_PROFILE_CHANGE_ORGANIZATION}
          >
            {t('header.main.b2b-user-menu.change-organization')}
          </UserMenuItem>
        )}
        <UserMenuItem icon={SignOutIcon} onClick={props.onLogout} data-qa={DATA_QA_B2B_PROFILE_LOGOUT}>
          {t('header.main.b2b-user-menu.exit')}
        </UserMenuItem>
      </FocusLock>
    </div>
  );
});
